// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert.alert-danger {
  font-size: 11px !important;
  font-weight: 600 !important;
  padding: 0.5em 1.25em !important;
  width: 100% !important;
}

::ng-deep .ng-option {
  position: relative !important;
}

.dialog-header {
  margin-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 0.75rem;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem;
  border-top: 1px solid #e0e0e0;
  margin-top: 1.5rem;
}
.button-container button {
  min-width: 100px;
  padding: 0.5rem 1.5rem;
}

.row:last-child {
  margin-top: 2rem;
}
.row:last-child .col-12 {
  padding: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/registry/customers/add-stable-organisation/add-stable-organisation.component.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,2BAAA;EACA,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,6BAAA;AACF;;AAGA;EACE,mBAAA;EACA,gCAAA;EACA,uBAAA;AAAF;;AAIA;EACE,aAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,kBAAA;AADF;AAGE;EACE,gBAAA;EACA,sBAAA;AADJ;;AAMA;EACE,gBAAA;AAHF;AAKE;EACE,UAAA;AAHJ","sourcesContent":[".alert.alert-danger{\r\n  font-size: 11px !important;\r\n  font-weight: 600 !important;\r\n  padding: 0.5em 1.25em !important;\r\n  width: 100% !important;\r\n}\r\n\r\n::ng-deep .ng-option {\r\n  position: relative !important;\r\n}\r\n\r\n// Miglioramento layout pulsanti modale\r\n.dialog-header {\r\n  margin-bottom: 1rem;\r\n  border-bottom: 1px solid #e0e0e0;\r\n  padding-bottom: 0.75rem;\r\n}\r\n\r\n// Container per i pulsanti di azione\r\n.button-container {\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 0.75rem;\r\n  padding: 1rem;\r\n  border-top: 1px solid #e0e0e0;\r\n  margin-top: 1.5rem;\r\n  \r\n  button {\r\n    min-width: 100px;\r\n    padding: 0.5rem 1.5rem;\r\n  }\r\n}\r\n\r\n// Stile per l'ultima row che contiene i pulsanti\r\n.row:last-child {\r\n  margin-top: 2rem;\r\n  \r\n  .col-12 {\r\n    padding: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
